module.exports = __webpack_public_path__ + "img/11088020_L.487ce891.png";